export const BeloppsregleringName = "Beloppsreglering";
export const KortterminalVlName = "Kortterminal VL";
export const B2bFakturaName = "B2B Faktura";
const Names = [BeloppsregleringName, KortterminalVlName, B2bFakturaName] as const;
type ReservedNames = typeof Names[number];

export class PointOfSale {
    id: string;
    name: ReservedNames | string;
    account: string;
}